var map = {
	"./avatar-1.jpg": 682,
	"./avatar-2.jpg": 1202,
	"./avatar-3.jpg": 1203,
	"./avatar-4.jpg": 1204,
	"./avatar-5.jpg": 2620,
	"./cover.jpg": 2621,
	"./img-avatar-1.jpg": 2622,
	"./img-avatar-2.jpg": 2623,
	"./img-avatar-3.jpg": 2624,
	"./lock.png": 2625,
	"./user-1.png": 2626,
	"./user-2.png": 2627,
	"./user.png": 2628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1201;